import { useSaveVisaRequestDraftMutation } from '../../../redux/api/questionnaire/questionnaire-api';
import useDraft from '../common/draft/useDraft';

export const useVisaDraft = () => {
  return useDraft(
    questionnaire => questionnaire.visaRequestForm,
    useSaveVisaRequestDraftMutation
  );
};
